import cx from 'classnames';
import React from 'react';

import styles from './styles.less';

export interface Video {
    id: string;
}

interface Props {
    ads?: boolean;
    darkMode?: boolean;
    id: string;
    onAdComplete?(video: Video, event: any): void;
    onAdStart?(video: Video, event: any): void;
    onVideoComplete?(video: Video, event: any): void;
    onVideoEnded?(video: Video, event: any): void;
    onVideoFinished?(video: Video, event: any): void;
    onVideoPause?(video: Video, event: any): void;
    onVideoPlaying?(video: Video, event: any): void;
    video: Video;
}

export enum ASVideoPlayerEvent {
    AD_COMPLETE = 'ad-complete',
    AD_START = 'ad-start',
    FINISHED = 'finished',
    PAUSED = 'paused',
    PLAYING = 'playing',
}

export const PLAYER_TYPE = 'ASVP';
export const BLANK_MP4 = 'https://pmd.cdn.turner.com/xslo/cvp/assets/video/blank.mp4';
export const DARK_MODE = 'dark-mode';

export default class ASPlayer extends React.Component<Props & React.HTMLAttributes<HTMLDivElement>> {

    private id = this.props.id;
    private player: any = null;
    private playingEventListener: any = null;

    componentDidMount() {
        this.player = new window.ASVideoPlayer(this.id, this.props.video.id, { ads: this.props.ads });
        this.player.registerEvent(ASVideoPlayerEvent.AD_COMPLETE, this.handleAdComplete);
        this.player.registerEvent(ASVideoPlayerEvent.AD_START, this.handleAdStart);
        this.player.registerEvent(ASVideoPlayerEvent.FINISHED, this.handleVideoFinished);
        this.player.registerEvent(ASVideoPlayerEvent.PAUSED, this.handleVideoPause);
    }

    componentDidUpdate(prevProps) {
        if (this.props.video.id !== prevProps.video.id) {
            this.play();
        }
    }

    componentWillUnmount() {
        this.player.destroy(false);
        this.player = undefined;
    }

    render() {
        return (
            <div
                className={ cx(styles.asPlayer, this.props.className, { [DARK_MODE]: this.props.darkMode }) }
                style={ this.props.style }
            >
                <video
                    autoPlay
                    id={ this.id }
                    preload='none'
                    src={ BLANK_MP4 }
                />
            </div>
        );
    }

    play() {
        if (this.playingEventListener) {
            this.playingEventListener();
        }
        this.playingEventListener = this.player.registerEvent(ASVideoPlayerEvent.PLAYING, this.handleVideoPlaying);
        this.player.setVideo(this.props.video.id, {
            success: () => {
                const player = this.player.getPlayer();
                player.currentTime(0);
                player.play();
            },
        });
    }

    private handleAdComplete = event => {
        this.props.onAdComplete && this.props.onAdComplete(this.props.video, event);
    }

    private handleAdStart = event => {
        this.props.onAdStart && this.props.onAdStart(this.props.video, event);
    }

    private handleVideoFinished = event => {
        this.props.onVideoFinished && this.props.onVideoFinished(this.props.video, event);
    }

    private handleVideoPause = event => {
        this.props.onVideoPause && this.props.onVideoPause(this.props.video, event);
    }

    private handleVideoPlaying = event => {
        this.props.onVideoPlaying && this.props.onVideoPlaying(this.props.video, event);
    }
}
